import styled, { css } from 'styled-components';

import { TranslatableText } from '@dreryk/react-common';

import { MedicalLeaveCommonFormController } from '../../common.types';
import { MedicalLeaveFormSection } from '../MedicalLeaveFormSection';

import { CityField } from './CityField';
import { CountryField } from './CountryField';
import { FlatField } from './FlatField';
import { HouseField } from './HouseField';
import { PostcodeField } from './PostcodeField';
import { StreetField } from './StreetField';

export const StyledMedicalLeaveFormStayAddressSectionGrid = styled.div`
   display: grid;
   grid-template-columns: repeat(4, 1fr);
   gap: 24px;

   ${['country', 'city', 'postcode', 'street', 'house', 'flat'].map(
      (name) => css`
         .${name} {
            grid-area: ${name};
         }
      `
   )}

   grid-template-areas:
      "country country country ."
      "city city city postcode"
      "street street street street"
      "house flat . .";
`;

StyledMedicalLeaveFormStayAddressSectionGrid.displayName = 'StyledMedicalLeaveFormStayAddressSectionGrid';

type MedicalLeaveFormStayAddressSectionProps = Pick<MedicalLeaveCommonFormController, 'register' | 'watch'> & {
   readonly title: TranslatableText;
};

export const MedicalLeaveFormStayAddressSection = (props: MedicalLeaveFormStayAddressSectionProps): JSX.Element => (
   <MedicalLeaveFormSection title={props.title}>
      <StyledMedicalLeaveFormStayAddressSectionGrid>
         <CountryField register={props.register} />
         <CityField register={props.register} />
         <PostcodeField register={props.register} watch={props.watch} />
         <StreetField register={props.register} />
         <HouseField register={props.register} />
         <FlatField register={props.register} />
      </StyledMedicalLeaveFormStayAddressSectionGrid>
   </MedicalLeaveFormSection>
);
